// extracted by mini-css-extract-plugin
export default {"root":"TwoUp-root-3JA","left":"TwoUp-left-2k-","right":"TwoUp-right-2o8"};